//
//
//
//
//
//
//
//

export default{
	name:'eloading',
	props:{
			showLoading:{//是否显示headerbar
				type:Boolean,
				default:true
			}
		}
}	
